import { Alignment, Api, ModelRow, StringUtil } from "@mcleod/core";
import { Component, DataSourceMode, DataSourceModeChangeEvent, DropdownItem, Layout, Textbox } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";
import { AutogenLayoutEdiStatusDetailTab } from "./autogen/AutogenLayoutEdiStatusDetailTab";
import { setBatchCodeTooltip } from "./EdiUtility";

export class EdiStatusDetailTab extends AutogenLayoutEdiStatusDetailTab {

     override onLoad(): void {

        this.mainDataSource.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            if (this.mainDataSource.mode === DataSourceMode.SEARCH) {
                this.textboxDelayCode.lookupModelDisabled = true;
                this.textboxStatusCode.lookupModelDisabled = true;
            }
            else{
                this.textboxDelayCode.lookupModelDisabled = false;
                this.textboxStatusCode.lookupModelDisabled = false;
            }

        });
    }


    delayCodeBeforeLookupModelSearch(event) {
        const eventType = this.sourceEdistatus.activeRow?.get("event_type");
        let codeType = "DelayReason";

        if (eventType == "AP") {
            codeType = "AppointmentReason";
        }

        event.filter.stop_id = this.sourceEdistatus.activeRow?.get("curr_stop_id");
        event.filter.customer_id = this.sourceEdistatus.activeRow?.get("customer_id");
        event.filter.code_type = codeType;
        event.filter.partner_id = this.sourceEdistatus.activeRow?.get("partner_id");
        event.filter.version = this.sourceEdistatus.activeRow?.get("version");
    }

    statusCodeBeforeLookupModelSearch(event) {
        event.filter.alt_partner_id = this.sourceEdistatus.activeRow?.get("alt_partner_id") ?? null;
        event.filter.partner_id = this.sourceEdistatus.activeRow?.get("partner_id");
        event.filter.direction = this.sourceEdistatus.activeRow?.get("direction");
        event.filter.version = this.sourceEdistatus.activeRow?.get("version");
        event.filter.curr_stop_type = this.sourceEdistatus.activeRow?.get("curr_stop_type");
    }

    setQuickInfoListeners() {
        const row = this.sourceEdistatus.activeRow;
        this.textboxStatusCode.addLookupModelSelectionListener(() => {
            this.makeStatusCodeTooltipContent(row);
        });
        this.textboxStatusCode.addDataDisplayListener(() => { this.makeStatusCodeTooltipContent(row); })
        this.textboxDelayCode.quickInfoOverrideSearchMethod = async (layout: Layout, keyValue: any) => {
            await layout.mainDataSource.search({ standard_code: keyValue });
        };
        setBatchCodeTooltip(this.textboxBatch, row, "S", Alignment.TOP);
        this.textboxStopDescription.quickInfoOverrideSearchMethod = async (layout: Layout, keyValue: any) => {
            const activeRow = this.sourceEdistatus.activeRow;
            if (activeRow == null) return;
            let dataRow: ModelRow;
            if (activeRow.get("status_code") === "X6") {
                dataRow = new ModelRow("lme/datafusion/edistatus", false, {
                    curr_stop_type: activeRow.get("curr_stop_type"),
                    curr_loc_id: activeRow.get("cons_loc_id"),
                    curr_loc_name: activeRow.get("cons_loc_name"),
                    curr_address: activeRow.get("cons_address"),
                    curr_city_name: activeRow.get("cons_city_name"),
                    curr_state: activeRow.get("cons_state"),
                    curr_zip_code: activeRow.get("cons_zip_code"),
                    curr_contact_name: activeRow.get("cons_contact_name_inbound"),
                    curr_phone: activeRow.get("cons_phone_inbound"),
                    curr_latitude: activeRow.get("cons_latitude_inbound"),
                    curr_longitude: activeRow.get("cons_longitude_inbound"),
                    partner_stop_no: activeRow.get("partner_stop_no"),
                    curr_plant: activeRow.get("consignee_plant")
                });
            } else {
                dataRow = new ModelRow("lme/datafusion/edistatus", false, {
                    curr_stop_type: activeRow.get("curr_stop_type"),
                    curr_loc_id: activeRow.get("curr_loc_id"),
                    curr_loc_name: activeRow.get("curr_loc_name"),
                    curr_address: activeRow.get("curr_address"),
                    curr_city_name: activeRow.get("curr_city_name"),
                    curr_state: activeRow.get("curr_state"),
                    curr_zip_code: activeRow.get("curr_zip_code"),
                    curr_contact_name: activeRow.get("curr_contact_name"),
                    curr_phone: activeRow.get("curr_phone"),
                    curr_latitude: activeRow.get("curr_latitude"),
                    curr_longitude: activeRow.get("curr_longitude"),
                    partner_stop_no: activeRow.get("partner_stop_no"),
                    curr_plant: activeRow.get("curr_plant")
                });
            }
            layout.mainDataSource.data = [dataRow];
            layout.mainDataSource.rowIndex = 0;
        };
    }

    makeStatusCodeTooltipContent(row: ModelRow<any>) {
        const sourceID = row?.get("id");
        if (sourceID != null) {
            CommonTooltips.setTooltipContentLayout(this.textboxStatusCode, null, "lme/datafusion/EdiStatusCodeQuickInfo", null, { "id": sourceID });
            this.textboxStatusCode.tooltipDynamicOptions = { position: Alignment.BOTTOM };
        }

    }


    afterExecution() {
        const row = this.mainDataSource.activeRow;
        if (row) {
            this.initialize(row);
        }
    }

    private _showFieldsByDirection(row: ModelRow<any>, createStatus: boolean) {
        const direction = row?.get("direction");
        if (createStatus) {
            this.textboxShipMatchType.visible = false;
            this.textboxShipMatchDescr.visible = false;
            this.textboxStopDescription.enabled = true;
            this.textboxDelayCode.enabled = true;
            this.textboxBatch.enabled = false;
            this.textboxStatusCode.required = true;
            this.textboxAppointmentDate.required = true;
            this.textboxStatusDate.required = true;
        } else {
            if ("I" == direction) {
                //enabled
                this.textboxStatusCode.enabled = false;
                this.textboxStopDescription.enabled = false;
                this.textboxAppointmentDate.enabled = false;
                this.textboxEta.enabled = false;
                this.textboxTimezoneId.enabled = false;
                this.textboxDelayCode.enabled = false;
                this.textboxBatch.enabled = false;
                this.textboxReadyToSend.enabled = false;
                this.textboxStatusDate.enabled = false;
                this.textboxShipMatchType.enabled = false;
                this.textboxShipMatchDescr.enabled = false;
                //caption
                this.textboxStopDescription.caption = "Location";
                this.textboxReadyToSend.caption = "Status";
                //visible
                this.textboxSourceRecordType.visible = false;
                this._generateTransmissionLogQuickInfo(this.textboxReadyToSend);
            } else {
                this.textboxShipMatchType.visible = false;
                this.textboxShipMatchDescr.visible = false;
            }
        }
    }

    private _generateTransmissionLogQuickInfo(component: Component) {
        if (this.mainDataSource?.activeRow?.get("batch") > "0") {
            CommonTooltips.setTooltipContentLayout(component, null, "lme/datafusion/TransmissionStatusQuickInfo", null,
                {
                    "direction": "I",
                    "batch": this.mainDataSource.activeRow.get("batch"),
                    "func_sender_id": this.mainDataSource.activeRow.get("partner_id"),
                    "sender_id": this.mainDataSource.activeRow.get("alt_partner_id"),
                    "func_version": this.mainDataSource.activeRow.get("version"),
                    "transaction_type": "S"
                }
            );
            component.tooltipDynamicOptions = { position: Alignment.LEFT };
        }
    }

    /** This is an event handler for the onChange event of textboxStopDescription. */
    async textboxStopDescriptionOnChange(event) {
        if (!this.mainDataSource.activeRow) {
            return;
        }
        if (this.textboxStopDescription.items != undefined) {
            const selectedItem = this.textboxStopDescription.selectedItem;
            if (selectedItem) {
                const selectedValue: number = parseInt(selectedItem.value) + 1;
                if (selectedValue >= 0) {
                    const stopsList = this.mainDataSource.activeRow.get("stops") as any[];
                    const stop = stopsList?.find(item => item.order_sequence === selectedValue);
                    this.sourceEdistatus.activeRow.setValues(stop);
                    this.sourceEdistatus.activeRow.set("curr_city_name_inbound", stop?.curr_city_name);
                    this.sourceEdistatus.activeRow.set("curr_state_inbound", stop?.curr_state);
                    this.sourceEdistatus.activeRow.set("curr_zip_code_inbound", stop?.curr_zip_code);
                    this.sourceEdistatus.activeRow.set("events", stop?.events);
                    this.sourceEdistatus.redisplayRow(0, this.activeRow ?? null, null);
                    this.textboxStopDescription.selectedItem = selectedItem;
                }
            }
            /****for later use with advanced search
            Api.search("lme/dispatch/stop", { "order_id": this.mainDataSource.activeRow.get("order_id") }).then(result => {
                const stopType = result.data[selectedValue]["stop_type"];
                const stopNum = (selectedValue == result.data.length -1 )?"99":(selectedValue == 0)?"00": result.data[selectedValue]["order_sequence"];
                //at this point we need to port some logic to a TS util class from RowEdiStatusEvent ==> public static String getStopType(String stopNumber, String stopType)
            });
             */

        }
    }

    /** This is an event handler for the onChange event of textboxStatusCode. */
    textboxStatusCodeOnChange(event) {
        // Check if activeRow exists before accessing it (prevents errors after deletion)
        if (!this.mainDataSource.activeRow) {
            return;
        }

        const statusCode = this.mainDataSource.activeRow.get("status_code");
        if ("X6" == statusCode) {
            this.textboxAppointmentDate.enabled = false;
            this.textboxAppointmentDate.required = false;
            this.mainDataSource.activeRow.set("appointment_date", this.textboxStatusDate.text);
        } else {
            this.textboxAppointmentDate.enabled = true;
            this.textboxAppointmentDate.required = true;
        }
        const statusEvent = this.mainDataSource.activeRow.get("events")?.find(event => event.status_code === statusCode);
        if (statusEvent) {
            const eventType = statusEvent?.event_type;
            this.setDropdown(this.textboxEventType, eventType, "event_type", this.mainDataSource.activeRow);
            // Set xmit_sequence from the selected event
            if (statusEvent.xmit_sequence != null) {
                this.mainDataSource.activeRow.set("xmit_sequence", statusEvent.xmit_sequence);
            }
        }
    }

    async checkStatusDate() {
        const row = this.mainDataSource.activeRow;
        if (!row) {
            return;
        }
        if (row.get("event_type") === "AP") {
            row.set("status_date", this.textboxAppointmentDate.text);
            const timezone = await Api.post("lme/datafusion/get-timezone", { status_date: row.get("status_date"), city_id: row.get("curr_city_id") });
            this.setDropdown(this.textboxTimezoneId, timezone.data[0].timezone, "timezone", row);
        }
    }

    async checkAppointmentDate() {
        const row = this.mainDataSource.activeRow;
        if (!row) {
            return;
        }
        if (row.get("event_type") === "AP" || row.get("status_code") === "X6") {
            row.set("appointment_date", this.textboxStatusDate.text);
            const timezone = await Api.post("lme/datafusion/get-timezone", { status_date: row.get("status_date"), city_id: row.get("curr_city_id") });
            this.setDropdown(this.textboxTimezoneId, timezone.data[0].timezone, "timezone", row);
        }
    }

    initialize(row: ModelRow, createStatus: boolean = false) {
        this.setQuickInfoListeners();
        this._showFieldsByDirection(row, createStatus);
        const stopDescrptionItems: DropdownItem[] = [];
        //will be used by advanced search, need to complete code to set stop_type on status row so that appropriate status codes appear in lookup model
        for (let x = 0; x < row.get("stops_list")?.length; x++) {
            stopDescrptionItems.push(new DropdownItem((x).toString(), row.get("stops_list")[x]));
        }
        this.textboxStopDescription.items = stopDescrptionItems;
        const statusCode = row.get("status_code");
        if ("X6" == statusCode || "EN" == statusCode) {
            this.textboxStopDescription.caption = "Next Stop Number";
            if ("X6" == statusCode) {
                this.textboxAppointmentDate.visible = false;
            }
        }

        // Force refresh of all textboxes to display current data
        this.sourceEdistatus.redisplayRow(0, row, null);
    }

    setDropdown(textbox: Textbox, value: string, fieldToSet: string, currentRow: ModelRow<any>) {
        const items = textbox.items as DropdownItem[];
        const dropdownItem = items.find(item => item.value === value);
        if (dropdownItem) {
            textbox.selectedItem = dropdownItem;
            currentRow.set(fieldToSet, dropdownItem.value);
        }
    }
}
